import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const PulseIcon: FC<AllieIconProps> = () => (
  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="14.5" r="4" fill="#8CB6BC" />
    <circle cx="24" cy="34.5" r="4" fill="#F8FAFC" />
    <circle cx="14" cy="24.5" r="4" fill="#F472B6" />
    <circle cx="34" cy="24.5" r="4" fill="#FB923C" />
  </svg>
);
